export const pageObj = {
  pageName: "Category Settings",
  betaPage: false
};

export const categorySettingsPages = {
  TUTORIAL: "TUTORIAL",
  CREATE_CATEGORY: "CREATE_CATEGORY",
  CATEGORY_DETAILS: "CATEGORY_DETAILS",
  ADD_TICKET_TYPE: "ADD_TICKET_TYPE",
  ISSUE_TYPE: "ISSUE_TYPE"
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/categorySettings/categorySettingsHelper.js